/**
 * List pages (parties, teams): GA list view event and create-button tracking
 */
import { on } from '../utils/events';

export function initListPage() {
    // Which filters people browse and how many (fresh) parties they get back
    const listData = document.querySelector('.parties-list')?.dataset.gaList;
    if (listData) {
        gtag('event', 'view_party_list', JSON.parse(listData));
    }

    // Every "create" entry point carries data-cta with its location and data-cta-type, so the entry points can be compared.
    // Promote buttons have data-cta alone (the location for promote_open), they are not a create entry
    on('click', '[data-cta][data-cta-type]', (e, link) => trackCreateCta(link.dataset.cta, link.dataset.ctaType));
}

export function trackCreateCta(location, formType) {
    gtag('event', 'create_cta_click', {
        'location': location,
        'form_type': formType,
    });
}
